<template>
  <div class="dropdown" @mousedown="(e) => e.preventDefault()">
    <div class="dropdown-header">
      <a-checkbox
        class="title"
        @change="handleChangeAll"
        v-model:checked="allChecked"
      ></a-checkbox>
      <span class="title-label" @click="handleChangeAll">
        {{ title }}
      </span>
    </div>
    <div class="dropdown-list">
      <a-checkbox-group v-model:value="value">
        <div v-for="opt in options" :key="opt.label" class="dropdown-list-item">
          <a-checkbox
            :value="opt.value"
            class="dropdown-list-item-checkbox"
          ></a-checkbox>
          <span
            class="dropdown-list-item-label"
            @click="handleClickCheckboxLabel(opt)"
          >
            {{ opt.label }}
          </span>
        </div>
      </a-checkbox-group>
    </div>
    <div class="dropdown-actions">
      <a-button type="link" class="clear" @click="handleClear">
        Clear All
      </a-button>
      <a-button class="cancel" @click="handleCancel">Cancel</a-button>
      <a-button type="primary" @click="handleApply">Apply</a-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DashboardDropdownRender',
    props: {
      title: {
        type: String,
      },
      list: {
        type: Array,
      },
      type: {
        type: String,
      },
      selected: {
        type: Array,
      },
    },
    data() {
      return {
        allChecked: false,
        value: [],
      }
    },
    computed: {
      options() {
        return this.list.map((el) => ({ label: el, value: el }))
      },
    },
    mounted() {
      this.value = this.selected
    },
    watch: {
      selected: {
        handler(val) {
          this.value = val
        },
      },
      value: {
        handler(val) {
          this.allChecked = val.length == this.options.length
        },
      },
    },
    methods: {
      handleChangeAll() {
        if (this.value.length == this.options.length) {
          this.allChecked = false
          this.value = []
        } else {
          this.allChecked = true
          this.value = this.options.map((el) => el.value)
        }
      },
      handleClear() {
        this.value = []
        this.allChecked = false
      },
      handleCancel() {
        this.$emit('cancel', false, this.type)
      },
      handleApply() {
        this.$emit('query', this.value, this.type)
      },
      handleClickCheckboxLabel(opt) {
        if (this.value.indexOf(opt.label) === -1) {
          this.value = [...this.value, opt.label]
        } else {
          this.value = this.value.filter((e) => e !== opt.label)
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  .dropdown {
    &-header {
      .title {
        padding: 12px;

        &-label {
          font-weight: bold;
          font-size: 14px;
          color: black;
          cursor: pointer;
        }
      }
    }

    &-list {
      max-height: 300px;
      overflow-y: scroll;
      padding: 12px;

      &-item {
        margin-bottom: 12px;

        &-checkbox {
          margin-right: 12px;
        }

        &-label {
          cursor: pointer;
          font-weight: normal;
        }
      }
    }

    &-actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 12px;
      border-top: 1px solid #f0f0f0;

      .clear {
        margin-right: 16px;
      }

      .cancel {
        margin-right: 16px;
      }
    }
  }
</style>
